import { AirtableBase } from "@/types/crm/airtable/common"
import { ApiErrors, NotFoundError } from "@/types/crm/airtable/errors"

export async function getAirtableBases(personalAccessToken?: string ): Promise<
| { bases: AirtableBase[], error: undefined, offset: string } 
| { error: NotFoundError } 
| { error: { type: ApiErrors, message: string } }
> {
    if (!personalAccessToken) {
        throw new Error('Personal Access Token is required to fetch Airtable bases')
    }
    const res = await fetch(`https://api.airtable.com/v0/meta/bases/`, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${personalAccessToken}`
        }
    })
        .then(res => res.json())
    if (res.error) {
        // console.log(res.error)
        if (typeof res.error === 'string')
            throw new Error(res.error)
        throw new Error(res.error.type)
    }
    return res
}